import styled from "@emotion/styled";
import { rem } from "@triumph/design-system";
import { Link } from "react-router-dom";

import { ILinkStyledProps } from "./Link.types";

const LinkCss = ({ small, theme }: ILinkStyledProps) => `
    color: ${theme.colors.link.default};
    
    :hover {
        color: ${theme.colors.link.hover};
    }
    :focus-visible {
        outline: ${rem(3)} solid ${theme.colors.accessibility.focused};
        outline-offset: ${rem(1)};
    }
    :visited {
        color: ${theme.colors.link.default};
    }
    :active {
        ${theme.colors.link.active}
    }
    font-size: ${
      small
        ? theme.typography.fontSizes.body.small
        : theme.typography.fontSizes.body.default
    };

    letter-spacing: ${theme.typography.letterSpacings.default}; 
	line-height: ${theme.typography.lineHeights.body.medium};

    &.invert-color {
        color: ${theme.colors.greyscale.white};

        :hover {
            color: ${theme.colors.greyscale.white};
        }
        :visited {
            color: ${theme.colors.greyscale.white};
        }
        :active {
            color: ${theme.colors.greyscale.white};
        }
    }
`;

export const StyledReactRouterLink = styled(Link)(LinkCss);
export const UnhandledRouterLInk = styled.span(LinkCss);
